import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installSwalAsGlobalAlert } from './lib/swal'

// Reemplaza window.alert por SweetAlert2 en toda la app sin tocar cada sitio.
installSwalAsGlobalAlert()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
